// extracted by mini-css-extract-plugin
export var hidden = "_wh-0";